import { render, staticRenderFns } from "./CaseConfigPermissionFeatures.vue?vue&type=template&id=137ff52e"
import script from "./CaseConfigPermissionFeatures.vue?vue&type=script&lang=js"
export * from "./CaseConfigPermissionFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports